module.exports = __webpack_public_path__ + "img/offline.5d34a5ff.svg";